<ion-content class="safe-area-top">

    <app-modal-header></app-modal-header>

    <div class="content-spacing">
        <app-template-content [code]="'PRIVACY'"></app-template-content>
    </div>

</ion-content>
